module.exports = __webpack_public_path__ + "static/german_logo-9b95641f061b578a6386b766de106540.png";